export enum UserRoleType {
  ADMIN = 'Administrador',
  SUPERUSER = 'Super Usuário',
  USER = 'Usuário',
}
